export default __webpack_public_path__ + "static/media/thumbnail.8d86a3e8.png";